// 导入所有文章数据（包含内容）
import article1 from './articles/article_1.js'
import article2 from './articles/article_2.js'
import article3 from './articles/article_3.js'
import article4 from './articles/article_4.js'
import article5 from './articles/article_5.js'
import article6 from './articles/article_6.js'
import article101 from './articles/article_101.js'
import article102 from './articles/article_102.js'
import article103 from './articles/article_103.js'
import article201 from './articles/article_201.js'
import article202 from './articles/article_202.js'
import article203 from './articles/article_203.js'
import article300 from './articles/article_300.js'
import articleDayunshan101 from './articles/article_dayunshan_101.js'
import articleDayunshan102 from './articles/article_dayunshan_102.js'
import articleDayunshan103 from './articles/article_dayunshan_103.js'
import articleDayunshan104 from './articles/article_dayunshan_104.js'
import articleDayunshan105 from './articles/article_dayunshan_105.js'
import articleDayunshan106 from './articles/article_dayunshan_106.js'
import articleDayunshan107 from './articles/article_dayunshan_107.js'
import articleDayunshan108 from './articles/article_dayunshan_108.js'
import articleDayunshan201 from './articles/article_dayunshan_201.js'
import articleDayunshan202 from './articles/article_dayunshan_202.js'
import articleDayunshan109 from './articles/article_dayunshan_109.js'
import articleHuizhou101 from './articles/article_huizhou_101.js'

// 创建文章数据映射
const mockArticles = {
  [article1.id]: article1,
  [article2.id]: article2,
  [article3.id]: article3,
  [article4.id]: article4,
  [article5.id]: article5,
  [article6.id]: article6,
  [article101.id]: article101,
  [article102.id]: article102,
  [article103.id]: article103,
  [article201.id]: article201,
  [article202.id]: article202,
  [article203.id]: article203,
  [article300.id]: article300,
  [articleDayunshan101.id]: articleDayunshan101,
  [articleDayunshan102.id]: articleDayunshan102,
  [articleDayunshan103.id]: articleDayunshan103,
  [articleDayunshan104.id]: articleDayunshan104,
  [articleDayunshan105.id]: articleDayunshan105,
  [articleDayunshan106.id]: articleDayunshan106,
  [articleDayunshan107.id]: articleDayunshan107,
  [articleDayunshan108.id]: articleDayunshan108,
  [articleDayunshan109.id]: articleDayunshan109,
  [articleDayunshan201.id]: articleDayunshan201,
  [articleDayunshan202.id]: articleDayunshan202,
  [articleHuizhou101.id]: articleHuizhou101
}

// 获取文章详情
export const mockArticleDetail = (id) => {
  return mockArticles[id] || null
}
